module.exports = __webpack_public_path__ + "img/kontakt.a4b00bc1.jpg";